import { Component, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-confirmationmodal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirmationmodal.component.html',
  styleUrl: './confirmationmodal.component.scss'
})
export class ConfirmationmodalComponent {
  @Input() title!: string;
  @Input() message : SafeHtml = '';
  @Input() mode = 'Add';

  constructor(public dialogRef: MatDialogRef<ConfirmationmodalComponent>,) {

  }

  confirm() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }
  onClose() {
    this.dialogRef.close();
  }
}
